module.exports = __webpack_public_path__ + "static/media/production-catering.8897c598.jpg";